import React, { Component } from 'react';
import './DynamicTable.css';

class DailyCard extends Component {
  render() {
    // console.log(this.props);

    const { tableData } = this.props;
    let data;
    let header = [];
    let dataTwo = [];
    for (let key in tableData) {
      header.push(key)
      dataTwo.push(tableData[key])

    }


    function TableHeader() {
      let head = header.map((value) => (
        <th>{value}</th>
      ))
      return (
        <thead>
          <tr>
            {head}
          </tr>
        </thead>
      )
    }

    function TableData() {
      let data = dataTwo.map((value) => (
        <th>{value}</th>
      ))
      return (

        <tr>
          {data}
        </tr>


      )
    }



    return (
      <div className="miniCard" >
        <h4 className="miniCardTitle">{this.props.title}</h4>
        <table className="miniCardTable">
          <TableHeader />
          <TableData />
        </table>
      </div>
    )
  }
}


export default DailyCard;